<script>
    import { onMount } from "svelte";

    import ERAsDefaultTable from "./ERAsDefaultTable.svelte";
    import ERAsReconcile from "./ERAsReconcile.svelte";

    export let params = {};

    let isShowReconcileTable = false,
        selectedReconciliationEraID = Number(0);

    onMount(() => {
        checkIsShowReconcileTable();
    });

    const checkIsShowReconcileTable = () => {
        if (!params.query) return;

        const arr = params.query.split("&");

        if (arr.some((attr) => attr.includes("selectedReconciliationEraID="))) {
            selectedReconciliationEraID = Number(
                arr
                    .find((attr) =>
                        attr.includes("selectedReconciliationEraID=")
                    )
                    .replace("selectedReconciliationEraID=", "")
            );
            isShowReconcileTable = true;
        }
    };

    const toggleShowERAsTable = (eraID) => {
        if (eraID) selectedReconciliationEraID = Number(eraID);
        else selectedReconciliationEraID = Number(0);

        isShowReconcileTable = !isShowReconcileTable;
    };
</script>

<div class="flex flex-col flex-1 gap-y-4">
    {#if isShowReconcileTable}
        <ERAsReconcile
            {params}
            {toggleShowERAsTable}
            {selectedReconciliationEraID}
        />
    {:else}
        <ERAsDefaultTable {params} {toggleShowERAsTable} />
    {/if}
</div>
